// extracted by mini-css-extract-plugin
export default {"main":"styles_main__fMP8V"};